import { mapActions, mapMutations, mapGetters } from 'vuex'
import { useCookies } from '@vueuse/integrations/useCookies'
import Swal from 'sweetalert2'
import { useSessionManagement } from '@/app/composables/useSessionManagement'
import { useGuestsCount } from '@/app/composables/useGuestsCount'
import { LocalStorage } from '@/app/services/storage.service'
import { formatDate } from '../helper'
import { LOCAL_STORAGE_KEY_SORT_BY } from '../rooms-sorters'

export default {
  data() {
    return {
      sessionManager: null,
      guestsCountHelper: null
    }
  },
  computed: {
    ...mapGetters(['guestsBounds', 'isAdultsOnlyHotel']),
    guestsCountString() {
      return this.guestsCountHelper.guestsCountString
    }
  },
  created() {
    this.sessionManager = useSessionManagement()
    this.guestsCountHelper = useGuestsCount()
  },
  methods: {
    ...mapMutations([
      'UPDATE_CURRENT_ROOM_STAY',
      'UPDATE_ORDER_INFO',
      'UPDATE_BOOKING_REQUEST',
      'ADD_ORDER_TO_ROOM_STAY',
      'COMPLETE_ROOM_STAY_BOOKING',
      'SET_LOADING'
    ]),
    clearAndRefreshSession() {
      LocalStorage.removeItem('reservation')
      LocalStorage.removeItem('roomId')
      LocalStorage.removeItem(LOCAL_STORAGE_KEY_SORT_BY)
      this.sessionManager.clearSession()
      this.sessionManager.refreshSession()
    },
    sessionExpirationHandler() {
      return this.sessionManager.handleSessionExpiration()
    },
    getAvailabilitiesWithUpdatedDates(dates) {
      if (dates) {
        this.UPDATE_BOOKING_REQUEST({
          checkIn: dates.start,
          checkOut: dates.end
        })
        this.submitSearchInfo()
        this.$store.dispatch('getRoomsAvailabilities')
      }
    },
    submitCurrentRoomStayInfo(roomId, product) {
      this.UPDATE_ORDER_INFO({
        product, // back compatibility.
        products: {
          // TODO: refactor (no property "products" in getter "orderInfo")
          ...this.$store.getters.orderInfo.products,
          [product.reference]: product
        }
      })
      this.UPDATE_CURRENT_ROOM_STAY({
        ...product,
        guestRoomId: roomId,
        productId: product.productId,
        ratePlanId: product.rate.ratePlanCode,
        reference: product.reference
      })
    },
    addOrderToRoomStay(roomId, productId) {
      const product = this.$store.state.productsAvailable.find(
        (product) => product.productId === productId
      )
      const room = this.$store.getters.roomById(product.guestRoomId)

      if (product) {
        this.submitCurrentRoomStayInfo(product.guestRoomId, product)
        this.UPDATE_CURRENT_ROOM_STAY({
          productId,
          room: room.room,
          currency: this.$store.getters.currency,
          totalPrice: product.totalPrice,
          hotelTotalPrice: product.hotelTotalPrice,
          totalDiscount:
            product.totalDiscount ??
            product.discount /* + services discount? */,
          hotelTotalDiscount: product.hotelTotalDiscount
        })
        const order = { ...this.$store.getters.currentRoomStay }
        order.startDate = formatDate(order.startDate)
        order.endDate = formatDate(order.endDate)

        this.ADD_ORDER_TO_ROOM_STAY({
          order,
          roomStayIndex: this.$store.getters.currentRoom
        })
      }
    },
    goToServices(roomId) {
      this.loading = true

      if (!this.$store.getters.currentRoomStay.hasServices) {
        this.COMPLETE_ROOM_STAY_BOOKING(this.$store.getters.currentRoom)
        if (this.$store.getters.isAllRoomStaysBooked) {
          this.$router.push({ name: 'CheckoutGuestInfo' }).catch(() => {})
        } else {
          this.bookNextRoom()
        }
        return
      }

      LocalStorage.setItem('roomId', roomId)
      setTimeout(() => {
        this.$router
          .push({ name: 'CheckoutAddServices', params: { roomId } })
          .catch(() => {})
      }, 200)
    },
    async goHomeAndReload(doReload = false) {
      if (this.$route.name === 'home') {
        if (doReload) {
          location.reload()
        }
        return
      }

      await this.$router.push({ name: 'home' })
      if (doReload) {
        location.reload()
      }
    },
    submitSearchInfo() {
      this.sessionManager.submitSearchInfo()
    },
    bookNextRoom() {
      setTimeout(() => {
        LocalStorage.removeItem('priceRange')
        this.submitSearchInfo()
        this.goHomeAndReload()
        this.$store.dispatch('getRoomsAvailabilities')
      })
    }
  }
}
